import {Types} from "../../../../type/Types";

export type PlaceValueObject = {
    id: bigint;
    adminId: bigint | null;
    isActive: boolean;
    exposedAt: Date;
    placeMissionType: number;
    placeNumber: string | null;
    placeName: string | null;
    placeImageUrl: string | null;
    placeTelephoneNumber: string | null;
    answer: string | null;
    placeUrl: string | null;
    attractionNameString: string | null;
    keywordString: string | null;
    amount: bigint | null;
    amountBeforeRefresh: bigint | null;
    successCount: bigint;
    failureCount: bigint;
    reportCount: bigint;
    createdAt: Date;
    modifiedAt: Date | null;
    crawlerHandledAt: Date | null;
    deletedAt: Date | null;
}

export namespace PlaceValueObject {
    export function construct(o: any): PlaceValueObject {
        return {
            id: BigInt(o.id),
            adminId: BigInt(o.adminId),
            isActive: Boolean(o.isActive),
            exposedAt: new Date(o.exposedAt),
            placeMissionType: Number(o.placeMissionType),
            placeNumber: Types.asNull(o.placeNumber, String),
            placeName: Types.asNull(o.placeName, String),
            placeImageUrl: Types.asNull(o.placeImageUrl, String),
            placeTelephoneNumber: Types.asNull(o.placeTelephoneNumber, String),
            answer: Types.asNull(o.answer, String),
            placeUrl: Types.asNull(o.placeUrl, String),
            attractionNameString: Types.asNull(o.attractionNameString, String),
            keywordString: Types.asNull(o.keywordString, String),
            amount: Types.asNull(o.amount, BigInt),
            amountBeforeRefresh: Types.asNull(o.amountBeforeRefresh, BigInt),
            successCount: BigInt(o.successCount),
            failureCount: BigInt(o.failureCount),
            reportCount: BigInt(o.reportCount),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            crawlerHandledAt: Types.asNull(o.crawlerHandledAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o))
        }
    }

    export const description: Record<keyof PlaceValueObject, string> = {
        id: 'ID',
        adminId: '관리자 ID',
        isActive: '활성 여부',
        exposedAt: '노출 일자',
        placeMissionType: '미션 종류',
        placeNumber: '플레이스 번호',
        placeName: '이름',
        placeImageUrl: '이미지 URL',
        placeTelephoneNumber: '전화번호',
        answer: '정답',
        placeUrl: 'URL',
        attractionNameString: '명소',
        keywordString: '키워드',
        amount: '수량',
        amountBeforeRefresh: '부활 전 수량',
        successCount: '성공',
        failureCount: '실패',
        reportCount: '신고',
        createdAt: '생성 일자',
        modifiedAt: '수정 일자',
        crawlerHandledAt: '크롤러 응답 데이터 마지막 핸들 일자',
        deletedAt: '삭제 일자'
    }
}